import { render, staticRenderFns } from "./MyActive.vue?vue&type=template&id=1fa09614&"
import script from "./MyActive.vue?vue&type=script&lang=js&"
export * from "./MyActive.vue?vue&type=script&lang=js&"
import style0 from "./MyActive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports